<template>
  <div class="footer">
    <div class="footer-main relative">
      <slot name="logo">
        <img class="logo" src="../../assets/logo.png" />
      </slot>
      <slot>
        <ul class="menu-list">
          <li class="title">
            <y-text>{{ t("shell.footer.company") }}</y-text>
          </li>
          <li>
            <y-text>{{ t("shell.footer.about") }}</y-text>
          </li>
          <li>
            <y-text>{{ t("shell.footer.contact") }}</y-text>
          </li>
        </ul>
        <ul class="menu-list">
          <li class="title">
            <y-text>{{ t("shell.footer.terms") }}</y-text>
          </li>
          <li>
            <y-text>{{ t("shell.footer.termsConditions") }}</y-text>
          </li>
          <li>
            <y-text>{{ t("shell.footer.privacy") }}</y-text>
          </li>
          <li>
            <y-text>{{ t("shell.footer.faq") }}</y-text>
          </li>
        </ul>
        <img
          class="ewm"
          src="https://qiniu-uploads-cdn.charmdeer.com//Fn4wc7h5FBQAWOjLQnSb5UmhBPhu_84.png"
        />
      </slot>
    </div>
    <slot name="bottom">
      <div v-if="showCopyRight" class="copy-right">
        <y-text>{{ t("shell.footer.copyrights") }}</y-text>
      </div>
    </slot>
  </div>
</template>
<script lang="ts" setup>
import { useI18n } from "vue-i18n";
const { t } = useI18n();
interface IProps {
  showCopyRight?: boolean;
}
withDefaults(defineProps<IProps>(), {
  showCopyRight: true
});
</script>

<style scoped>
.footer {
  width: 100%;
  color: #fff;
  background: #282828;
  padding-top: 52px;
  padding-bottom: 40px;
}
.footer-main {
  display: var(--y-footer-info-display, flex);
  width: 1080px;
  margin: 0 auto 36px;
}
.logo {
  display: block;
  width: 179px;
  height: 32px;
}
.menu-list {
  margin-left: 100px;
  min-height: 128px;
}

.menu-list + .menu-list {
  margin-left: 140px;
}
.menu-list > li {
  line-height: 1;
  --y-text-color: rgba(255, 255, 255, 0.8);
  --y-text-font-family: var(--y-medium-font);
  --y-text-font-size: 14px;
  margin-top: 16px;
}
.menu-list > li:not(.title):hover {
  --y-text-color: #fff;
  text-decoration-line: underline;
  cursor: pointer;
  font-weight: 500;
}

.menu-list > li.title {
  --y-text-font-family: var(--y-title-font);
  --y-text-font-size: 20px;
  --y-text-color: #ffffff;
  margin-top: 0;
  margin-bottom: 20px;
}
.ewm {
  position: absolute;
  right: 0;
  width: 128px;
  height: 128px;
}
.copy-right {
  text-align: center;
  font-size: 12px;
  opacity: 0.5;
  --y-text-color: #fff;
}
</style>
